var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.5C22 19.37 18.87 22.5 15 22.5L16.05 20.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5C2 5.63 5.13 2.5 9 2.5L7.95001 4.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.5C20.9853 11.5 23 9.48528 23 7C23 4.51472 20.9853 2.5 18.5 2.5C16.0147 2.5 14 4.51472 14 7C14 9.48528 16.0147 11.5 18.5 11.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49959 18C7.99536 18 9.20793 16.7875 9.20793 15.2917C9.20793 13.7959 7.99536 12.5834 6.49959 12.5834C5.00382 12.5834 3.79126 13.7959 3.79126 15.2917C3.79126 16.7875 5.00382 18 6.49959 18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.153 23.4167C11.153 21.3204 9.06758 19.625 6.50008 19.625C3.93258 19.625 1.84717 21.3204 1.84717 23.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManCircle);
export default __webpack_public_path__ + "static/media/man-circle.27c9ec02461c920c7ec5b6b11c534b9a.svg";
export { ForwardRef as ReactComponent };